import { render, staticRenderFns } from "./answerRecord.vue?vue&type=template&id=1c7f21ec&scoped=true"
import script from "./answerRecord.vue?vue&type=script&lang=js"
export * from "./answerRecord.vue?vue&type=script&lang=js"
import style0 from "./answerRecord.vue?vue&type=style&index=0&id=1c7f21ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7f21ec",
  null
  
)

export default component.exports